.input-group input{font-weight:400}
/*# sourceMappingURL=analytics-table-search-header.component-D2HZZ4EE.css.map */
